module.exports = __webpack_public_path__ + "static/media/virtual_report.8e5e0f18.svg";